import React from 'react';
import PropTypes from 'prop-types';

import FlexList from './ListComponents/FlexList';

const ListHorizontalWithFlex = ({ renderItem, items, columns, childSpacing }) => {
  return (
    <FlexList childSpacing={childSpacing} columns={columns} flexWrap={'wrap'}>
      {items.map((item, index) => {
        return React.cloneElement(renderItem(item, index));
      })}
    </FlexList>
  );
};

ListHorizontalWithFlex.propTypes = {
  renderItem: PropTypes.func,
  items: PropTypes.array,
};

ListHorizontalWithFlex.defaultProps = {
  renderItem: () => {},
  items: [],
};

export default ListHorizontalWithFlex;
